import fileSaver from 'file-saver';

export const saveFile = (fileName: string, path: string) => {
  fileSaver.saveAs(`${path}${fileName}`, `${fileName}`);
};
